<template>
    <div class="content-body">
        <div class="container pd-x-0">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                <div>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                            <li class="breadcrumb-item"><a href="/">Modules</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Accounts Services</li>
                        </ol>
                    </nav>
                    <h4 class="mg-b-0 tx-spacing--1">Welcome to Dashboard</h4>
                </div>
                <div class="d-none d-md-block">
                    <router-link to="/" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><MailIcon /> Main Board
                    </router-link>

                    <a href="http://businessaccount.rubies.ng/" target="_blank" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><FileIcon />
                        Business Account
                    </a>
                </div>
            </div>
            <!--TODO CHART-->
            <AccountChart/>
            <!--TODO HISTORY-->
            <History/>
        </div>
        <!-- container -->
    </div>
</template>

<script>
    import History from "../../components/card/History";
    import {mapState} from "vuex"
    import {MailIcon, FileIcon} from "vue-feather-icons"
    import AccountChart from "../../components/card/AccountChart";

    export default {
        name: 'Home',
        data() {
            return {
                items: [],
                label: [],
                data: [],
            }
        },
        components: {
            AccountChart,
            History,
            MailIcon,
            FileIcon
        },
        computed: {
            companyid: function () {
                return this.$store.state.auth.customerid
            },
            authobj: function () {
                return this.$store.state.auth.response
            },


            ...mapState(['account'])
        },

        methods: {
            getaccountstats: async function () {
                const payload = {customerid: this.authobj.customerid};
                await this.$store.dispatch("account/updateChartData", payload, {root: false});
            }
        },
        mounted() {
            //this.getaccountstats()
        }
    }
</script>
